import { useContext, useMemo } from "react";
import { useAuth } from "./useAuth";
import SubscriptionStatusContext from "../context/SubscriptionStatusContext";
import { SubscriptionStatus } from "../lib/types";

export enum UserState {
  uninitialized,
  loading,
  unauthenticated,
  canRegisterForTrial,
  paymentRequired,
  subscribed,
}

const useUserState = () => {
  const { user, loading } = useAuth();
  const subscriptionInfo = useContext<SubscriptionStatus | null>(
    SubscriptionStatusContext
  );

  const userState = useMemo(() => {
    if (loading) {
      return UserState.loading;
    }

    if (!user) {
      return UserState.unauthenticated;
    }

    if (subscriptionInfo === null) {
      return UserState.loading;
    }

    if (subscriptionInfo.subscription.basic.hasSubscription) {
      return UserState.subscribed;
    }

    if (subscriptionInfo.subscription.basic.hasTrial) {
      return UserState.canRegisterForTrial;
    }

    return UserState.paymentRequired;
  }, [user, loading, subscriptionInfo]);

  return { userState, subscriptionInfo };
};

export default useUserState;
